<template>
  <div class="skeleton-wrapper">
    <div class="top">
      <div class="item1">
        <div class="item1-1 skeleton"></div>
        <div class="item1-2 skeleton"></div>
      </div>
      <div class="item2 skeleton"></div>
      <div class="item3 skeleton"></div>
      <div class="item4 skeleton"></div>
      <div class="item4 skeleton"></div>
      <div class="item4 skeleton"></div>
      <div class="item4 skeleton"></div>
    </div>
    <div class="bottom">
      <div class="item5" v-for="item in 4" :key="item">
        <div class="item5-1 skeleton"></div>
        <div class="item5-2 skeleton"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
  .skeleton-wrapper {
    .top {
      padding: 20px 20px 84px;
      background: #ffffff;
      box-shadow: 0px 1px 6px 0px rgba(3, 47, 129, 0.03);
      border-radius: 6px;
      margin-bottom: 16px;

      .item1 {
        display: flex;
        margin-bottom: 24px;
        .item1-1,
        .item1-2 {
          flex: 1;
          height: 48px;
        }
        .item1-1 {
          margin-right: 15px;
        }
      }

      .item2 {
        height: 88px;
        margin-bottom: 24px;
      }

      .item3 {
        height: 24px;
        margin-bottom: 16px;
      }

      .item4 {
        height: 74px;
        margin-bottom: 12px;

        &:last-of-type {
          margin-bottom: 0;
        }
      }

    }
    .bottom {
      display: flex;
      justify-content: space-between;
      padding: 16px 30px 14px;
      background: #ffffff;
      box-shadow: 0px 1px 6px 0px rgba(3, 47, 129, 0.03);
      border-radius: 6px;

      .item5 {
        display: flex;
        flex-direction: column;
        align-items: center;

        .item5-1 {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          margin-bottom: 6px;
        }

        .item5-2 {
          width: 52px;
          height: 20px;
        }

      }
    }
    .skeleton {
      background: #F9F9F9;
      border-radius: 6px;
      background-size: 400% 100%;
      background-image: -webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(0.25, rgb(242, 242, 242)), color-stop(0.37, rgb(230, 230, 230)), color-stop(0.63, rgb(242, 242, 242)));
      background-image: gradient(linear, 0% 0%, 100% 0%, color-stop(0.25, rgb(242, 242, 242)), color-stop(0.37, rgb(230, 230, 230)), color-stop(0.63, rgb(242, 242, 242)));
      animation: ant-skeleton-loading 1.4s ease infinite;
      @keyframes ant-skeleton-loading{0%{background-position:100% 50%}100%{background-position:0 50%}}
    }
  }
</style>
